<!-- 우측 하단 플로팅 내비게이션 -->
<template>
  <div v-show="isFloatingFlag && (showGotoTop || showAiTutor)" id="floatNav" style="z-index: 1000">
    <ul>
      <!-- AI Tutor -->
      <li v-show="showAiTutor">
        <button type="button" class="btn_ai_tutor" @click.prevent="aiTutor">AI Tutor</button>
      </li>
      <!-- // AI Tutor -->

      <!-- Goto top -->
      <li v-show="showGotoTop && !isScrollTop">
        <button type="button" class="btn_goto_top" @click.prevent="gotoTop">상단으로 이동</button>
      </li>
      <!-- // Goto top -->
    </ul>
  </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'

export default {
  name: 'FloatNav',
  components: {
    VueScrollTo
  },
  props: {
    // Goto top 버튼 노출 여부 (기본값 false)
    showGotoTop: {
      type: Boolean,
      default: false
    },
    // AI Tutor 버튼 노출 여부 (기본값 false)
    showAiTutor: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      scrollTopValue: 200, // 페이지 스크롤 위치값이 해당 값보다 큰 경우 top 을 벗어났다고 판단
      isScrollTop: false // 현재 스크롤 위치가 top 인지 여부
    }
  },
  computed: {
    isFloatingFlag () {
      // console.log('isFloatingFlag', window.location.href)
      if (window.location.href.indexOf('/promo/') > -1) return false// promo가 포함된 event URL은 플로팅바 자체 사용
      return true
    }
  },
  mounted () {
    this.chkScrollPosition() // 현재 스크롤 위치 계산하여 스크롤이 상단에 도달했는지 여부 설정
    window.addEventListener('scroll', this.chkScrollPosition, true)
    window.addEventListener('resize', this.chkScrollPosition, true)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.chkScrollPosition, true)
    window.removeEventListener('resize', this.chkScrollPosition, true)
  },
  methods: {
    aiTutor () {
      console.log('AI Tutor')
    },
    // 최상단 스크롤 이동
    gotoTop () {
      const target = '#app'
      VueScrollTo.scrollTo(target)
    },
    // 현재 스크롤 위치가 top 인지 여부
    chkScrollPosition () {
      const currScrollY = window.scrollY
      if (currScrollY > this.scrollTopValue) {
        this.isScrollTop = false
      } else {
        this.isScrollTop = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/CompFloatNav.vue